var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUxui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 2.83337H4.66671C3.37804 2.83337 2.33337 3.87804 2.33337 5.16671V7.50004C2.33337 8.7887 3.37804 9.83337 4.66671 9.83337H18.6667C19.9554 9.83337 21 8.7887 21 7.50004V5.16671C21 3.87804 19.9554 2.83337 18.6667 2.83337Z",
    fill: "#FF8B63",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 19.1667V16.8334C11.6666 16.2145 11.9125 15.621 12.35 15.1835C12.7876 14.7459 13.3811 14.5 14 14.5H23.3333C23.9521 14.5 24.5456 14.2542 24.9832 13.8166C25.4208 13.379 25.6666 12.7855 25.6666 12.1667V8.66671C25.6666 8.04787 25.4208 7.45438 24.9832 7.01679C24.5456 6.57921 23.9521 6.33337 23.3333 6.33337H21",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 19.1666H10.5C9.85571 19.1666 9.33337 19.689 9.33337 20.3333V25C9.33337 25.6443 9.85571 26.1666 10.5 26.1666H12.8334C13.4777 26.1666 14 25.6443 14 25V20.3333C14 19.689 13.4777 19.1666 12.8334 19.1666Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUxui);
export default __webpack_public_path__ + "static/media/Icon-UXUI.477d67b6dc28dd0d9c95d8205201dd40.svg";
export { ForwardRef as ReactComponent };